import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <StatusPageLayout
      variant="warning"
      title="Page not found"
      body={`We couldn't find ${window.location.pathname}. Check the link or return home.`}
      actions={
        <button type="button" className="ev-btn-primary" onClick={() => navigate('/welcome')}>
          Go to home
        </button>
      }
    />
  );
};

export default NotFound;
